import { Component, model, input, inject, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Checkbox } from 'primeng/checkbox';
import { LineItemModel } from '../../../../models/template.model';
import { SpeechService } from '../../../../services/speech.service';
import { ValidationService } from '../../../../services/validation.service';

@Component({
  selector: 'app-checkbox-control',
  standalone: true,
  imports: [CommonModule, FormsModule, Checkbox],
  template: `
    <div class="checklist-control-row">
      <label [for]="'checkbox-' + lineItem().lineItemId" class="checklist-control-label">
        {{ lineItem().name }}@if (lineItem().isRequired) { <span class="required-indicator">*</span>}
      </label>
      <div class="checklist-control-input">
        <div class="checkbox-shell" [class.checkbox-shell--error]="hasError()">
          <p-checkbox
            [inputId]="'checkbox-' + lineItem().lineItemId"
            [(ngModel)]="value"
            [disabled]="disabled()"
            [binary]="true"
            (onBlur)="onBlur()"
            (onChange)="onBlur()"
          />
        </div>
        @if (hasError()) {
          @for (err of errors(); track $index) {
            <small class="p-error d-block">{{ err }}</small>
          }
        }
      </div>
      <div class="ctrl-speaker-col">
        <button type="button" class="ctrl-speaker-btn" (click)="speakLabel()"
          [attr.aria-label]="'Read label: ' + lineItem().name">
          <i class="ri-volume-up-line"></i>
        </button>
      </div>
    </div>
  `,
  styles: [`
    .checkbox-shell {
      display: inline-flex;
      align-items: center;
      min-height: 2.5rem;
      padding: 0.5rem 0.75rem;
      border: 1px solid transparent;
      border-radius: 6px;
    }
    .checkbox-shell--error {
      border-color: #ef4444;
      background: #fef2f2;
    }
  `]
})
export class CheckboxControlComponent {
  lineItem = input.required<LineItemModel>();
  value = model<boolean>(false);
  disabled = input<boolean>(false);
  showError = input<boolean>(false);

  private speechService = inject(SpeechService);
  private validationService = inject(ValidationService);
  touched = signal(false);

  errors = computed(() => {
    if (!this.showError() && !this.touched()) return [];
    return this.validationService.validate(this.lineItem(), this.value());
  });

  hasError = computed(() => this.errors().length > 0);

  onBlur(): void {
    this.touched.set(true);
  }

  speakLabel(): void {
    this.speechService.speak(this.lineItem().name);
  }
}
